import SignUpInput from "components/SignUpInput";
import config from "config";
import { SectionWrapper } from "pages/Product/styled";
import { MainCopy, SubCopy } from "pages/styled";
import React from "react";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";

const HeroSectionWrapper = styled(SectionWrapper)`
  padding: 160px 16px 140px;
  text-align: center;
  position: relative;
  overflow: hidden; // 내부 이미지 때문에 가로 스크롤이 생기는 현상 제거
  min-height: 700px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  ${mediaMin.lg`
    min-height: 800px;
  `};
`;

const Images = styled.div`
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 64px;
  left: 0;
`;

const LeftImage = styled.img`
  position: absolute;
  object-fit: contain;
  height: 114px;
  margin-left: -236px;
  margin-top: 65px;

  ${mediaMin.xs`
    height: 140px;
    margin-left: -360px;
    margin-top: 64px;
  `};

  ${mediaMin.sm`
    margin-left: -440px;
  `};

  ${mediaMin.md`
    height: 210px;
    margin-left: -600px;
    margin-top: 80px;
  `};

  ${mediaMin.lg`
    height: 250px;
    margin-left: -760px;
    margin-top: 80px;
  `};
`;

const RightImage = styled.img`
  position: absolute;
  object-fit: contain;
  height: 96px;
  margin-left: 20px;
  margin-top: 520px;

  ${mediaMin.xs`
    height: 104px;
    margin-left: 180px;
    margin-top: 500px;
  `};

  ${mediaMin.sm`
    margin-left: 240px;
  `};

  ${mediaMin.md`
    height: 156px;
    margin-left: 300px;
    margin-top: 480px;
  `};

  ${mediaMin.lg`
    height: 200px;
    margin-left: 400px;
    margin-top: 520px;
  `};
`;

const ContentsWrapper = styled.div`
  z-index: 1;
`;

export function HeroSection() {
  return (
    <HeroSectionWrapper>
      <Images>
        <LeftImage
          src={`${config.RESOURCE_ORIGIN}/images/landing/product/hero-person-left.png`}
        />
        <RightImage
          src={`${config.RESOURCE_ORIGIN}/images/landing/product/hero-person-right.png`}
        />
      </Images>
      <ContentsWrapper>
        <MainCopy>
          The new standard
          <br />
          to work with clients
        </MainCopy>
        <SubCopy>
          Yess is the all-in-one productivity suite
          <br />
          that removes all procedural obstacles
        </SubCopy>
        <SignUpInput formId="product-hero-sign-up-form" />
      </ContentsWrapper>
    </HeroSectionWrapper>
  );
}
